import { atom } from "recoil";

export interface AttendanceSession {
    id: string;
    userId: string;
    locationId: string | null;
    clockInAt: string;
    isOpen: boolean;
    /** End time of the scheduled block covering "now", or null if none. */
    expectedStop: string | null;
}

/**
 * Holds the currently authenticated user's open attendance session, or null if not clocked in.
 * Hydrated on app init from GET /api/attendance/current-session.
 * Updated optimistically on successful clock-in / clock-out.
 */
export const currentSessionAtom = atom<AttendanceSession | null>({
    key: "currentSessionAtom",
    default: null,
});

/** Tracks whether the current session has been loaded from the API */
export const currentSessionLoadedAtom = atom<boolean>({
    key: "currentSessionLoadedAtom",
    default: false,
});
